var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReconnecticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.63,
    height: 17.63,
    viewBox: "0 0 17.63 17.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reconnect_icon",
    "data-name": "Reconnect icon",
    transform: "translate(46.735 -11.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Reconnect_icon-2",
    "data-name": "Reconnect icon",
    d: "M12.715,4a8.715,8.715,0,1,0,8.715,8.715.872.872,0,1,0-1.743,0,6.973,6.973,0,1,1-1.91-4.793h-1.14a.872.872,0,1,0,0,1.743h3.05a.872.872,0,0,0,.871-.871V5.743a.872.872,0,1,0-1.743,0V6.5A8.691,8.691,0,0,0,12.715,4Z",
    transform: "translate(-50.635 7.113)",
    fill: "#0f7bff",
    stroke: "#0f7bff",
    strokeWidth: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconnecticon);
export default __webpack_public_path__ + "static/media/Reconnect icon.93c440d7.svg";
export { ForwardRef as ReactComponent };